/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { createSelector } from 'reselect';
import { differenceInDays } from 'date-fns';
import { getPaymentMethod } from '../Checkout/ducks/Common/Common-Selectors';
import { getFeatureFlags } from '../Checkout/ducks/App/App-Selectors';

export const getIsDeliveryDateCutOffWindowForKlarnaEnabled = (state) => {
    const featureFlags = getFeatureFlags(state);

    return featureFlags['is-delivery-date-cutoff-window-for-klarna-enabled'];
};

export const getCutoffNumberOfDaysForKlarna = (state) => {
    const featureFlags = getFeatureFlags(state);

    return featureFlags['klarna-cut-off-number-of-days'] || 40;
};

const getRecipientOrderItems = (state) => state.mfeCheckout?.cart?.recipients || [];

const isItemClubItemPayByCreditCard = (item) => {
    let paymentMethodCode = -1;

    if (item.product?.paymentMethod !== '' && item.product?.paymentMethod !== null) {
        paymentMethodCode = item.product?.paymentMethod;
    }

    if (Number(paymentMethodCode) === 0) {
        return true;
    }

    return false;
};

const isSupbscriptionProduct = (item) => {
    if (item?.subscription?.type || item.product.seoUrl?.includes('subscription')) {
        return true;
    }

    return false;
};

export const getKlarnaSupportedItems = createSelector(
    [
        getIsDeliveryDateCutOffWindowForKlarnaEnabled,
        getRecipientOrderItems,
        getPaymentMethod,
    ],
    (isCutOffWindowEnabled, recipients, paymentMethodSelected) => {
        const supportedItems = [];

        if (isCutOffWindowEnabled && paymentMethodSelected?.id === 'Klarna' && recipients) {
            recipients.forEach((items) => {
                items.cartItems.forEach((cartItems) => {
                    const itemClubItemPayByCreditCard = isItemClubItemPayByCreditCard(cartItems);
                    const isPassportItem = cartItems.product.isPassport;
                    const isSubscriptionItem = isSupbscriptionProduct(cartItems);

                    if (!isPassportItem
                    && !itemClubItemPayByCreditCard
                    && !isSubscriptionItem) {
                        supportedItems.push(cartItems.cartItemId);
                    }
                });
            });
        }

        return supportedItems;
    },
);

export const getItemsDeliveryIsBeyondCutOffDateForKlarna = createSelector([
    getIsDeliveryDateCutOffWindowForKlarnaEnabled,
    getCutoffNumberOfDaysForKlarna,
    getRecipientOrderItems,
    getKlarnaSupportedItems,
    getPaymentMethod,
],
(
    isCutOffWindowEnabled,
    numberOfDaysCutOffWindow,
    recipients,
    supportedItems,
    paymentMethodSelected,
) => {
    const itemsDeliveryDateIsBeyondCutOffDate = [];

    if (isCutOffWindowEnabled && paymentMethodSelected?.id === 'Klarna' && recipients.length > 0) {
        recipients.forEach((items) => {
            items.cartItems.forEach((item) => {
                const orderItemId = item.cartItemId;

                if (supportedItems?.indexOf(orderItemId) >= 0 && item.deliveryInfo?.deliveryDate) {
                    const todayDate = new Date();
                    const deliveryDate = new Date(item.deliveryInfo.deliveryDate);
                    const noOfDaysFromTodayToDeliveryDate = differenceInDays(deliveryDate, todayDate);

                    if (noOfDaysFromTodayToDeliveryDate >= numberOfDaysCutOffWindow) {
                        itemsDeliveryDateIsBeyondCutOffDate.push(orderItemId);
                    }
                }
            });
        });
    }

    return itemsDeliveryDateIsBeyondCutOffDate;
});

export default {};
